import { CreditCard, Smartphone, Landmark, Wallet } from "lucide-react";

const METHODS = [
  ["card", "Tarjeta", "Visa, Mastercard · pago seguro Redsys", CreditCard],
  ["bizum", "Bizum", "Paga desde la app de tu banco", Smartphone],
  ["paypal", "PayPal", "Con tu cuenta PayPal", Wallet],
  ["transfer", "Transferencia", "Te enviamos el IBAN; enviamos al recibir el pago", Landmark],
];

export const MethodPicker = ({ value, onChange, paypal }) => (
  <fieldset data-testid="checkout-methods" className="mt-8">
    <legend className="font-serif-d font-black text-2xl mb-4">Forma de pago</legend>
    <div className="grid gap-2">
      {METHODS.filter(([id]) => id !== "paypal" || paypal).map(([id, title, sub, Icon]) => (
        <label key={id} data-testid={`method-${id}`}
          className={`flex items-center gap-4 rounded-[12px] border-2 p-4 cursor-pointer transition-[border-color,background-color] ${value === id ? "border-[#F2B441] bg-[#F2B441]/10" : "border-[#F6EEDC]/15 hover:border-[#8CD05A]/60"}`}>
          <input type="radio" name="method" value={id} checked={value === id} onChange={() => onChange(id)} className="sr-only" />
          <Icon className="w-6 h-6 text-[#8CD05A] shrink-0" aria-hidden />
          <span className="flex-1"><span className="block font-semibold">{title}</span><span className="block text-xs text-[#C9D6C2]">{sub}</span></span>
          <span className={`w-5 h-5 rounded-full border-2 grid place-items-center ${value === id ? "border-[#F2B441]" : "border-[#F6EEDC]/40"}`}>
            {value === id && <span className="w-2.5 h-2.5 rounded-full bg-[#F2B441]" />}
          </span>
        </label>
      ))}
    </div>
  </fieldset>
);
